'use client';

import { useState } from 'react';
import { Code } from 'lucide-react';
import { Button } from '@/components/ui/Button/Button';
import { analytics } from '@/lib/analytics';
import { EmbedModal } from './EmbedModal';

interface Props {
  tone: { id?: number | null; title?: string | null };
}

/**
 * "Embed" next to the tone page's player: opens the Share → Embed modal.
 * Render only for public tones — the embed page serves nothing else.
 */
export const EmbedButton = ({ tone }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        isSecondary
        onClick={() => {
          analytics.capture('tone.embed_modal.opened');
          setOpen(true);
        }}
        style={{ height: 50, paddingLeft: 16, paddingRight: 16 }}
        className="self-start flex-shrink-0 whitespace-nowrap"
        aria-label="Embed this player"
      >
        <Code size={20} />
        <span>Embed</span>
      </Button>
      <EmbedModal open={open} onClose={() => setOpen(false)} tone={tone} />
    </>
  );
};
